import { Alert, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import LayersIcon from '@mui/icons-material/Layers';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { ILimitacaoConsumoTable } from "../../../application/models";

interface ModalTiposConsumoProps {
    open: boolean;
    onClose: () => void;
    selectedGroup: ILimitacaoConsumoTable | null;
}

export const ModalTiposConsumo = ({ open, onClose, selectedGroup }: ModalTiposConsumoProps) => {
    if (!selectedGroup) return null;

    const quantidade = selectedGroup.Quantidade ? selectedGroup.Quantidade.toLocaleString('pt-BR') : '0';
    const totalTipos = selectedGroup.subRows?.length || 0;
    const produtoNome = selectedGroup.DescricaoProduto || selectedGroup.Descricao || 'Produto';

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 2 }
            }}
        >
            <DialogTitle sx={{ pb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LayersIcon color="primary" fontSize="large" />
                    <Box>
                        <Typography variant="h6" color="primary" fontWeight="bold">
                            Grupo de Trava Compartilhada
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Produto: <strong>{produtoNome}</strong>
                        </Typography>
                    </Box>
                </Box>
                <Chip 
                    label="GRUPO COMPARTILHADO" 
                    color="primary" 
                    size="small" 
                    sx={{ fontWeight: 'bold', fontSize: '0.7rem' }}
                />
            </DialogTitle>

            <DialogContent dividers>
                <Alert severity="info" icon={<LayersIcon />} sx={{ mb: 2.5, borderRadius: 1.5 }}>
                    <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                        Como funciona o consumo em grupo?
                    </Typography>
                    <Typography variant="body2">
                        O limite total de <strong>{quantidade} consumos</strong> é compartilhado dinamicamente entre as <strong>{totalTipos} variáveis</strong> abaixo. O consumo em qualquer uma delas desconta do mesmo saldo comum.
                    </Typography>
                </Alert>

                <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: 0.5 }}>
                    Variáveis Participantes do Grupo ({totalTipos})
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {selectedGroup.subRows?.map((subRow, index) => (
                        <Box
                            key={subRow.IdLimitacaoConsumo ?? subRow.IdTipoConsumo ?? index}
                            sx={{
                                p: 1.5,
                                borderRadius: 1.5,
                                backgroundColor: 'background.paper',
                                border: '1px solid',
                                borderColor: 'divider',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                                '&:hover': {
                                    borderColor: 'primary.light',
                                    backgroundColor: 'action.hover'
                                }
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Chip 
                                    label={`#${index + 1}`} 
                                    size="small" 
                                    sx={{ height: 22, fontSize: '0.7rem', fontWeight: 'bold', backgroundColor: 'action.selected' }}
                                />
                                <Typography variant="body2" fontWeight="600" color="text.primary">
                                    {subRow.Descricao}
                                </Typography>
                            </Box>
                            <CheckCircleOutlineIcon color="success" fontSize="small" />
                        </Box>
                    ))}
                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} variant="contained" color="primary" sx={{ px: 3 }}>
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
